import { MinimumAmountBasket } from "./MinimumAmountBasket";

export default MinimumAmountBasket;
